import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useSendDeconsolidation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (tsdId: string) => {
      const result = await apiClient.tsd.sendDeconsolidation.mutation({ params: { tsdId } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: (_, tsdId) => {
      queryClient.invalidateQueries({ queryKey: ['temporary-storages'] });
      queryClient.invalidateQueries({ queryKey: ['temporary-storage', tsdId] });
      toast.success('Deconsolidation sent!');
    },
    onError: (error, tsdId) => {
      queryClient.invalidateQueries({ queryKey: ['temporary-storages'] });
      queryClient.invalidateQueries({ queryKey: ['temporary-storage', tsdId] });
      showErrorToast(error, `Error sending deconsolidation!`);
    },
  });
};
